import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";

const Tile = ({ className, image, title, slug }) => (
  <Link to={slug} className={`pricing-tile ${className}`}>
    <article>
      <Img sizes={image} alt={title} />
      <div className="overlay">
        <p className="is-size-3" dangerouslySetInnerHTML={{ __html: title }} />
      </div>
    </article>
  </Link>
);

export default Tile;
